module.exports = __webpack_public_path__ + "img/step-3.548c4f48.png";